import _ from 'lodash';
import fetch from 'isomorphic-fetch';
import { setPageTotal } from './page';

export const REQUEST_POSTS = 'REQUEST_POSTS';
export function requestPosts(filters) {
    return { type: REQUEST_POSTS, filters };
}

export const RECEIVE_POSTS = 'RECEIVE_POSTS';
export function receivePosts(content) {
    return function(dispatch, getState) {
        dispatch({ type: RECEIVE_POSTS, content });
    };
}

export const SET_STATIC_HTML = 'SET_STATIC_HTML';
export function setStaticHtml(html) {
    return { type: SET_STATIC_HTML, html };
}

const getAPIEndpoint = state => {
    const homeUrl = _.result(window, 'SiteInfo.homeUrl', '');
    const apiEndpoint = `${homeUrl}/wp-json/vtl/${state.config.postType}/view`;
    let val = '';
    let queryArray = [
        { key: 'posts_per_page', value: state.config.pageLength },
        { key: 'paged', value: state.page.page }
    ];

    if (state.filter.text) {
        queryArray.push({
            key: 's',
            value: state.filter.text
        });
    }

    for (const filterKey of Object.keys(state.filter)) {
        val = state.filter[filterKey];
        if (!val) {
            continue;
        }

        switch (filterKey) {
            case 'text':
                break;

            default:
                let filterVals = val.map(f => ({
                    key: `${filterKey}[]`,
                    value: f.slug
                }));
                queryArray = queryArray.concat(filterVals);
        }
    }

    const queryString = queryArray
        .map(q => `${encodeURIComponent(q.key)}=${encodeURIComponent(q.value)}`)
        .join('&');

    return apiEndpoint + '?' + queryString;
};

export function fetchPosts() {
    return function(dispatch, getState) {
        dispatch(requestPosts());

        return fetch(getAPIEndpoint(getState()))
            .then(response => {
                dispatch(setPageTotal(response.headers.get('X-WP-TotalPages')));
                return response.json();
            })
            .then(json => {
                return dispatch(receivePosts(json));
            });
    };
}



// WEBPACK FOOTER //
// ./wp-content/themes/gwy/assets/scripts/source/vpm/post-grid/actions/posts.js